import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { firebase } from './api/auth/firebase';
import vuetify from './plugins/vuetify';
import vuegtag from 'vue-gtag';
import '@babel/polyfill';
import WidthLimitedMd from './components/utils/WidthLimitedMd.vue';

Vue.config.productionTip = false;

if (process.env.NODE_ENV === 'production') {
  console.log('loading GA');

  // Load google analytics
  Vue.use(
    vuegtag,
    {
      config: { id: 'UA-130950023-1' }
    },
    router
  );
} else {
  console.log('not loading GA');
}

Vue.component('width-limited-md', WidthLimitedMd);

new Vue({
  router,
  store: store.original,
  render: h => h(App),
  vuetify,

  created: () => {
    // This reads the user both on initial app load, and when
    // the login or signUp workflow returns with a user
    firebase.auth().onAuthStateChanged(firebaseUser => {
      if (firebaseUser) {
        if (!store.state.getStarted.isSigningIn) {
          store.dispatch.auth.signInFirebaseUser(firebaseUser);
        }
      }
    });
  }
}).$mount('#app');
